import {handleActions} from 'redux-actions';
import {Map} from 'immutable';

import * as ManagePlanActions from 'web-app/react/plans/manage-plan/actions';

import * as Actions from './actions';

export default handleActions(
    {
        [Actions.fetchPlansByChildIdsSuccess.type]: (state, {payload}) => {
            return payload.plans;
        },
        [ManagePlanActions.createPlanSuccess.type]: (state, {payload}) => {
            return state.set(payload.plan.id, payload.plan);
        },
    },
    Map(),
);
